import { t } from 'i18next';
import { ThumbnailPhotoCard } from '@peacecover/component';
import type { components } from '@pocapan/shared/types/schema';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';

type PhotoCard = components['schemas']['PhotoCard'];

interface PhotoCardContentProps {
  photoCard: PhotoCard;
  className?: string;
}

const PhotoCardContent = ({ photoCard, className }: PhotoCardContentProps) => {
  const handlePhotoCardClick = () => {
    if (photoCard?.photoCardId) {
      openNewTab(`/photo_cards/${photoCard?.photoCardId}`);
    }
  };

  if (photoCard?.photoCardId?.includes('temp')) {
    return (
      <div className="p-[12px] flex items-center gap-[8px] w-[212px] h-[84px] rounded-[16px] bg-pure-white dark:bg-separator2 border border-surface-lv2">
        <div className="w-[38px] h-[60px] rounded-[7px] bg-[#EEEEEE] dark:bg-[#232323]" />
        <div className="flex flex-col gap-[6px] items-start justify-center">
          <div className="w-[84px] h-[16px] rounded-[4px] bg-[#EEEEEE] dark:bg-[#232323]" />
          <div className="w-[142px] h-[16px] rounded-[4px] bg-[#EEEEEE] dark:bg-[#232323]" />
        </div>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={handlePhotoCardClick}
      className={`p-[12px] w-fit flex items-center gap-[8px] rounded-[16px] border border-surface-lv2 bg-pure-white dark:bg-pure-black ${className}`}
    >
      <ThumbnailPhotoCard
        imageUrl={photoCard.smallThumbnailUrl || photoCard.pictureUrl || ''}
        className="w-[38px] h-[60px]"
      />
      <div className="flex flex-col gap-[6px] items-start justify-center">
        <p className="text-[13px] font-semibold text-text-main-lv2 leading-[16px] text-left w-[142px] truncate">
          {t('NewTradingPhotoCards.photoCardTitle', {
            artist: photoCard.memberName,
            category: photoCard.categoryName,
            categoryEmoji: photoCard.categoryEmoji
          })}
        </p>
        <p className="text-[13px] font-medium text-text-main-lv4 leading-[16px] w-[142px] truncate text-left">
          {photoCard.eventName}
        </p>
      </div>
    </button>
  );
};

export default PhotoCardContent;
